import NavLink from 'react-router-dom/NavLink';
import styled from 'styled-components';

const FooterLink = styled(NavLink)`
  position: relative;
  display: inline-flex;
  text-decoration: none;
  -webkit-touch-callout: none;
  user-select: none;
  cursor: pointer;
  outline: 0;
  color: #fff;
`;

export default FooterLink;
